// Helper function to get variant text from item
export const getVariantText = (item) => {
  let variantText = '';
  
  if (item.productOptions && item.productOptions.length > 0) {
    variantText = item.productOptions.map(opt => `${opt.name}: ${opt.value}`).join(', ');
  } else if (item.size || item.color) {
    let variants = [];
    if (item.size) variants.push(`Size: ${item.size}`);
    if (item.color) variants.push(`Color: ${item.color}`);
    variantText = variants.join(', ');
  }
  
  return variantText;
};

// Helper function to get rental period text
export const getRentalPeriod = (item) => {
  if (item.rentalPeriod && item.rentalPeriod.duration) {
    const duration = item.rentalPeriod.duration;
    if (duration >= 30) {
      return `${Math.floor(duration / 30)} month${Math.floor(duration / 30) > 1 ? 's' : ''}`;
    } else if (duration >= 7) {
      return `${Math.floor(duration / 7)} week${Math.floor(duration / 7) > 1 ? 's' : ''}`;
    } else {
      return `${duration} day${duration > 1 ? 's' : ''}`;
    }
  }
  
  if (item.rentTimeSelect) {
    return item.rentTimeSelect.text || `${item.rentTimeSelect.value} days`;
  }
  
  return 'Standard rental';
};

// Helper function to get item price (rental or purchase)
export const getItemPrice = (item) => {
  if (item.isRental || item.rentalPeriod) {
    if (item.rentalPeriod && item.rentalPeriod.price) {
      return item.rentalPeriod.price * item.quantity;
    } else if (item.rentTimeSelect && item.rentTimeSelect.price) {
      return item.rentTimeSelect.price * item.quantity;
    } else if (item.rentPriceAndTime && item.rentPriceAndTime.length > 0) {
      return item.rentPriceAndTime[0].price * item.quantity;
    }
  }
  
  return item.price * item.quantity;
}; 